import React from "react";

const SortFilter: React.FC = () => {
  return (
    <div className="d-flex sort-and-filter gap-2 sort-by-filter">
      {/* <button className="btn btn-light sort-btn">
        Sort by: Expected Delivery
      </button>
      <button className="btn btn-light sort-btn">
        Filter: None
      </button> */}
    </div>
  );
};

export default SortFilter; 
